import React from 'react';
import { Link } from 'react-router-dom';

import { SERIE } from 'config/url';


const SeriePreview = ({name, tags, is_on_going, id}) => (
  <div className="column is-one-quarter">
    <Link to={SERIE(id)}>
      <div className="card serie-preview">
        <div className="p-3 m-0 has-background-primary-light">
          <h5 className="title is-5">{name}</h5>
        </div>
        <div className="card-content content p-3">
          {is_on_going &&
          <p className=""><b>Série en cours</b></p>
          }
          <div className="tags">
            {tags.map((tag) => <span className="tag">{tag}</span>)}
          </div>
        </div>
      </div>
    </Link>
  </div>
)

export default SeriePreview;